import React, { useEffect, useRef, useState } from 'react';
import BuilderSelct from '@/store/builderStoreSelector';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert, { AlertProps } from '@mui/material/Alert';

export const Alert = React.forwardRef<HTMLDivElement, AlertProps>(function Alert(
  props,
  ref,
) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

export default function BuilderNotification() {
  const [open, setOpen] = useState(false);
  const messageRef = useRef<{ severity: any; message: string, duration: number; }>({
    severity: '', message: '', duration: 0
  });
  const notificationMessage: { [key: string]: string | number } = BuilderSelct.ui().notificationMessage;

  const handleClose = (event?: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };

  useEffect(() => {
    if (notificationMessage.type != null) {
      messageRef.current.severity = notificationMessage.type;
      messageRef.current.message = notificationMessage.message as string;
      messageRef.current.duration = notificationMessage.duration as number;
    }
    messageRef.current.severity !== '' && messageRef.current.severity != null && setOpen(true);
  }, [notificationMessage])

  const autoHideDuration = messageRef.current.duration > 0 ? { autoHideDuration: messageRef.current.duration } : {};
  return (
    <Snackbar open={open}
      onClose={handleClose}
      anchorOrigin={{ 'vertical': 'top', 'horizontal': 'center' }}
      {...autoHideDuration}
    >
      <Alert onClose={handleClose} severity={messageRef.current.severity} sx={{ width: '100%' }}>
        {messageRef.current.message}
      </Alert>
    </Snackbar >
  );
}